import ChevronLeftIcon from "@assets/svg/ChevronLeftIcon"
import { ChevronDown, SearchIcon } from "lucide-react"
import { useEffect, useMemo, useState } from "react"
import { NavLink, useParams } from "react-router-dom"
import { useNavigate } from "react-router-dom"
import ApplicantCard from "./components/ApplicantCard"
import { getApplicantList, getMatchedJobById } from "@endpoints/job.service"
import { useSnackbar } from "notistack"
import LoadingAnimation from "@assets/svg/LoadingAnimation"

const ApplicantsListing = () => {
    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar()
    const { hiringCompanyId, jobId } = useParams()

    const [applicantList, setApplicantList] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    async function fetchApplicants() {
        try {
            setIsLoading(true)
            const { success, data } = await getApplicantList(jobId)
            if (success) {
                setApplicantList(data)
            }
        } catch (error) {
            enqueueSnackbar(error, { variant: 'error' })
        } finally {
            setIsLoading(false)
        }
    }

    const jobDetails = useMemo(() => {
        if (applicantList?.length) {
            return applicantList[0]?.jobDetails || {}
        } else {
            return {}
        }
    }, [applicantList?.length])

    useEffect(() => {
        if (jobId) {
            fetchApplicants()
        }
    }, [jobId])

    console.log('jobDetails', jobDetails)

    return <div className="flex flex-col flex-1 rounded-md bg-white min-h-0 p-5">
        {/* Back navigation container */}
        <div className="flex items-center gap-0.5">
            <button
                onClick={() => navigate("/job/by-hiring-company", { replace: true })}
                className="flex items-center self-start"
            >
                <ChevronLeftIcon className={"w-4 h-4"} fill="#4d4d4d" />
                <label className="text-xs font-medium text-primary cursor-pointer">Back</label>
            </button>
            <div className="flex items-center text-light-black pl-4 text-xs">
                <NavLink
                    to={'/job/by-hiring-company'}
                    className="font-semibold text-light-grey">View by hiring company</NavLink>&nbsp;{'>'}&nbsp;
                <NavLink
                    to={`/job/list-by-company/${hiringCompanyId}`}
                    className="font-semibold text-light-grey">Job Listing</NavLink>&nbsp;{'>'}&nbsp;

                <span className="font-semibold text-gray-500">Candidate Listing</span>
            </div>
        </div>
        {/* Job details */}
        <div className="flex flex-col mt-8 gap-3">
            <span className="text-xs text-light-black font-medium">{jobDetails?.refNo}</span>
            <div className="flex items-center gap-2">
                <div className="flex items-center pl-4 h-10 w-[45%] border text-xs font-bold rounded-md bg-light-white-700">{jobDetails?.title}</div>
                <div className="flex items-center justify-center px-5 h-10 border text-xs font-medium rounded-md text-primary bg-light-white-700">Applicants : ( {applicantList?.length || 0} )</div>
            </div>
        </div>
        {/* Top header */}
        <div className="flex items-center justify-between py-3.5 border-y mt-5">
            {/* Search container */}
            <div className="flex items-center w-max border rounded-md bg-gray-50 px-3">
                <input
                    className="w-56 text-xs font-medium bg-transparent outline-none h-9"
                    placeholder="Search..."
                />
                <SearchIcon color="gray" size={16} />
            </div>
            {/* Filters container */}
            <div className="flex items-center gap-3">
                <span className="text-primary text-xs font-medium">Filters by :</span>
                <div className="flex items-center gap-5 border rounded-md text-xs font-medium h-10 px-3">
                    Submitted
                    <ChevronDown strokeWidth={1} />
                </div>
            </div>

            <div className="flex items-center gap-3">
                <span className="text-primary text-xs font-medium">Filters by :</span>
                <div className="flex items-center gap-5 border rounded-md text-xs font-medium h-10 px-3">
                    Matched 40%-80%
                    <ChevronDown strokeWidth={1} />
                </div>
            </div>

            <div className="flex items-center gap-3">
                <span className="text-primary text-xs font-medium">Filters by :</span>
                <div className="flex items-center gap-5 border rounded-md text-xs font-medium h-10 px-3">
                    Favorites
                    <ChevronDown strokeWidth={1} />
                </div>
            </div>
        </div>
        {/* Table Section */}
        <div className="flex flex-col flex-1 min-h-0 mt-4">
            {/* <div className="items-end font-bold border-b pb-2 text-light-black text-xs grid gap-8 grid-cols-[3fr_0.3fr_0.3fr_0.3fr] px-2">
                <div className="flex flex-col pl-14 gap-1.5">
                    <span className="font-medium text-primary">{jobDetails?.refNo}</span>
                    <span className="font-bold text-primary">{jobDetails?.title}</span>
                </div>
                <span>Submitted</span>
                <span>Matched %</span>
                <span className="text-center">Favourite</span>
            </div> */}
            {/* List Section */}
            {
                isLoading ?
                    <div className="m-auto"><LoadingAnimation color="black" /></div>
                    :
                    !applicantList?.length ?
                        <span className="text-sm font-medium text-light-black m-auto">No applicants available.</span>
                        :
                        <div className="flex flex-col flex-1 min-h-0 overflow-y-scroll no-scrollbar">
                            {applicantList?.map((item) => {
                                return <ApplicantCard data={item} />
                            })}

                        </div>
            }
        </div>
    </div>
}

export default ApplicantsListing